import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HeartHandshake } from "lucide-react";

const PHRASES = [
  "عطاؤك اليوم بذرةُ خيرٍ تُثمر في قلوب الآخرين غداً 🌱",
  "كل ساعة تطوّع تكتبها… أثرٌ لا يُمحى وأجرٌ لا ينقطع 🤍",
  "أنت لا تصنع أرقاماً، بل تصنع ابتساماتٍ وتجبر خواطر 🌟",
  "المتطوّع الحقيقي يزرع الأمل حيث يظنّ الناس أن لا شيء يُنبت 🌸",
  "بصمتك في العطاء تبقى وإن غاب اسمك… فاجعلها جميلة ✨",
  "يدٌ تُعطي خيرٌ من ألف يدٍ تنتظر… كن أنت اليد المِعطاء 🤝",
  "خدمتك لمجتمعك عبادةٌ وشرفٌ ووسامٌ لا يُشترى 🏅",
  "ازرع الخير ولا تنتظر الثمر… فالله لا يُضيع أجر المُحسنين 🌿",
  "كن سبباً في سعادة أحدهم اليوم، فالسعادة تعود إليك أضعافاً 💛",
  "صغارُ الأعمال بنيّةٍ صادقة… تصير عند الله جبالاً من الحسنات ⛰️",
  "أنتم شموعٌ تُضيء دروب مدرستكم ومجتمعكم… فأنِيروا 🕊️",
  "لن تندم يوماً على لحظةٍ منحتَها لغيرك… العطاء لا يُنسى 🤲",
];

export default function InspireBanner() {
  const [i, setI] = useState(() => Math.floor(Math.random() * PHRASES.length));
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % PHRASES.length), 8000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="mb-5 rounded-2xl px-5 py-3 flex items-center gap-3 border border-sky-200/50 bg-gradient-to-l from-sky-50/80 to-amber-50/60 overflow-hidden" dir="rtl" data-testid="inspire-banner">
      <div className="w-9 h-9 rounded-xl icon-sky flex items-center justify-center shrink-0"><HeartHandshake size={20} /></div>
      <AnimatePresence mode="wait">
        <motion.p key={i} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.5 }} className="text-sm sm:text-base font-medium text-stone-700">
          {PHRASES[i]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
